// frontend/src/components/FinanceReport/Accounting/components/accounts/company-accounts/requests.js
import { authFetch } from "../../../../../api/api";


const BASE_URL = (process.env.REACT_APP_DJANGO_BACKEND || "").replace(/\/+$/, "");
const PROFIT_ALLOCATIONS_URL = `${BASE_URL}/api/accounting/profit-allocations/`;
const PROFIT_DOCS_URL = `${BASE_URL}/api/accounting/profit-allocation-documents/`;
const ACCOUNTS_URL = `${BASE_URL}/api/finances/accounts/`;
const CURRENCIES_URL = `${BASE_URL}/api/accounting/currencies/`;
const ACCOUNT_DETAIL_URL = (id) => `${ACCOUNTS_URL}${id}/`;

// --- Profit allocations ---
export async function getAllProfitAllocations() {
  const response = await authFetch(PROFIT_ALLOCATIONS_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function createProfitAllocation(payload) {
  const response = await authFetch(PROFIT_ALLOCATIONS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function patchProfitAllocation(id, patch) {
  const response = await authFetch(`${PROFIT_ALLOCATIONS_URL}${id}/`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(patch),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function deleteProfitAllocation(id) {
  const response = await authFetch(`${PROFIT_ALLOCATIONS_URL}${id}/`, { method: "DELETE" });
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  return { ok: true, status: response.status };
}

export async function uploadProfitAllocationDocument(profitId, file) {
  const fd = new FormData();
  fd.append("files", file);
  const response = await authFetch(`${PROFIT_ALLOCATIONS_URL}${profitId}/documents/`, {
    method: "POST",
    body: fd,
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function deleteProfitAllocationDocument(docId) {
  const response = await authFetch(`${PROFIT_DOCS_URL}${docId}/`, { method: "DELETE" });
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  return { ok: true, status: response.status };
}

// --- Accounts (счета компании) ---
export async function getAllAccounts() {
  const response = await authFetch(ACCOUNTS_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}

export async function getAccountById(id) {
  const response = await authFetch(ACCOUNT_DETAIL_URL(id));
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  return response.json();
}

export async function createAccount(payload) {
  const response = await authFetch(ACCOUNTS_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function updateAccount(id, payload) {
  const response = await authFetch(`${ACCOUNTS_URL}${id}/`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    const err = await response.json().catch(() => ({}));
    throw new Error(`HTTP ${response.status}: ${JSON.stringify(err)}`);
  }
  return response.json();
}

export async function deleteAccount(id) {
  const response = await authFetch(`${ACCOUNTS_URL}${id}/`, { method: "DELETE" });
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  return { ok: true, status: response.status };
}

// --- Currencies ---
export async function getAllCurrencies() {
  const response = await authFetch(CURRENCIES_URL);
  if (!response.ok) throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  const data = await response.json();
  return Array.isArray(data) ? data : data.results || [];
}